import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Base } from "components/template";
import { ProgressBar } from "components/molecules";
import { Button } from "components/atoms";
import { initialData } from "_config/store/onBoarding/onBoarding.thunk";
import { useLocalStorage, useOnBoarding } from "_hooks";

const prefix = "v-initial-data";

const InitialData = () => {
  const dispatch = useDispatch();
  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");
  const { state } = useLocation();
  const navigate = useNavigate();
  const initialized = useRef(null);
  const [value, setValue] = useState();

  const { fetchSalesChannels } = useOnBoarding();
  const { data: response, isLoading } = useSelector((s) => s.onBoarding.initialData);

  const onSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    dispatch(initialData(onBoarding?._id, {
      estimatedProductRange: value
    }))
  };

  useEffect(() => {
    if (!initialized?.current) {
      initialized.current = true;
      fetchSalesChannels({}, { feedback: { error: false}});
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (response !== null) {
      setOnBoarding(response);
      setTimeout(() => navigate("/account/salesChannels", { state }), 100);
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base
      align="normal"
      header={<ProgressBar max={6} progress={4} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3 ">
          
          <p className="text-center text-3xl font-bold mx-auto mt-5 mb-2">Cantidad de productos</p>
          <p className="text-center text-base mx-auto mb-10">Gestionados anualmente</p>
        
          <div className="grid grid-cols-2 gap-5">
            <button className={`${value === "1-10" && "bg-primary text-white"} border rounded min-h-10 text-lg transition ease-in-out hover:scale-105 hover:bg-purple-200`}
              onClick={() => setValue("1-10")}
            >1 a 10</button>
            <button className={`${value === "11-100" && "bg-primary text-white"} border rounded min-h-10 text-lg transition ease-in-out hover:scale-105 hover:bg-purple-200`} 
              onClick={() => setValue("11-100")}
            >11 a 100</button>
            <button className={`${value === "101-500" && "bg-primary text-white"} border rounded min-h-10 text-lg transition ease-in-out hover:scale-105 hover:bg-purple-200`} 
              onClick={() => setValue("101-500")}
            >101 a 500</button>
            <button className={`${value === "501-1000" && "bg-primary text-white"} border rounded min-h-10 text-lg transition ease-in-out hover:scale-105 hover:bg-purple-200`} 
              onClick={() => setValue("501-1000")}
            >501 a 1000</button>
            <button className={`${value === "1001-5000" && "bg-primary text-white"} border rounded min-h-10 text-lg transition ease-in-out hover:scale-105 hover:bg-purple-200`} 
              onClick={() => setValue("1001-5000")}
            >1001 a 5000</button>
            <button className={`${value === "5000+" && "bg-primary text-white"} border rounded min-h-10 text-lg transition ease-in-out hover:scale-105 hover:bg-purple-200`} 
              onClick={() => setValue("5000+")}
            >5000+</button>
          </div>

          <Button
            className="bg-primary text-white rounded-lg mt-5"
            disabled={isLoading || value === undefined}
            fullwidth
            height={10}
            pulse
            spin={isLoading}
            onClick={onSubmit}
          >Continuar</Button>
        </div>
      </div>
    </Base>
  )
};

export default InitialData;
